/**
 * El saludo según la hora LOCAL de quien mira, en un solo lugar (recorrido 3-nov: a la 1 de
 * la mañana Decisiones decía «Buenas noches» y el Inicio «Buenos días», porque cada pantalla
 * tenía su copia con bordes distintos). Bordes: 5, 12 y 19 h. «Buen día», como la maqueta.
 */
export function saludoDeLaHora(fecha: Date = new Date()): string {
  const h = fecha.getHours();
  if (h >= 5 && h < 12) return 'Buen día';
  if (h >= 12 && h < 19) return 'Buenas tardes';
  return 'Buenas noches';
}
